import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AwsEnvironment } from './environment';
import { AwsSignature } from './signature';

@Injectable()
export class AwsHttp {

    constructor(private http: Http, private signature: AwsSignature, private awsEnv: AwsEnvironment) { }

    get(url: string, options?: RequestOptionsArgs, signRequest = true): Observable<Response> {
        if (signRequest) {
            options = this.signRequest('GET', url, null, options);
        }

        return this.http.get(url, options);
    }

    post(url: string, body: any, options?: RequestOptionsArgs, signRequest = true): Observable<Response> {
        if (signRequest) {
            options = this.signRequest('POST', url, body, options);
        }

        return this.http.post(url, body, options);
    }

    put(url: string, body: any, options?: RequestOptionsArgs, signRequest = true): Observable<Response> {
        if (signRequest) {
            options = this.signRequest('PUT', url, body, options);
        }

        return this.http.put(url, body, options);
    }

    delete(url: string, options?: RequestOptionsArgs, signRequest = true): Observable<Response> {
        if (signRequest) {
            options = this.signRequest('DELETE', url, null, options);
        }

        return this.http.delete(url, options);
    }

    private signRequest(method: string, url: string, body?: any, options?: RequestOptionsArgs): RequestOptionsArgs {
        let request = {
            method: method,
            url: url,
            headers: {},
            data: (body ? body : '')
        };
        if (options && options.headers) {
            for (let header of options.headers.keys()) {
                request.headers[header] = options.headers.get(header);
            }
        }

        let result = this.signature.signRequest(request, this.awsEnv.getCredentials(), this.awsEnv.getApiRegion(), 'execute-api');

        if (!options) {
            options = {};
        }

        if (!options.headers) {
            options.headers = new Headers();
        }

        options.headers.append('Authorization', result['Authorization']);
        options.headers.append('x-amz-date', result['x-amz-date']);
        options.headers.append('x-amz-content-sha256', result['x-amz-content-sha256']);
        options.headers.append('x-amz-security-token', result['x-amz-security-token']);

        return options;
    }

}



// WEBPACK FOOTER //
// ./src/app/aws/http.ts